import React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

/**
 * Custom Tooltip Component with consistent gray-500 styling
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Trigger element
 * @param {string} props.content - Tooltip content text
 * @param {string} props.side - Tooltip position (top, right, bottom, left)
 * @param {number} props.delayDuration - Delay before showing tooltip
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.contentProps - Additional props for TooltipContent
 */
const CustomTooltip = ({
  children,
  content,
  side = "top",
  delayDuration = 0,
  className = "",
  contentProps = {},
  ...props
}) => {
  // If content is empty, null, or undefined, just return children without tooltip
  if (!content || (typeof content === 'string' && content.trim() === '')) {
    return children;
  }

  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip {...props}>
        <TooltipTrigger asChild>
          {children}
        </TooltipTrigger>
        <TooltipContent 
          side={side}
          className={`bg-gray-500 text-white border-gray-600 p-3 whitespace-normal ${className}`}
          {...contentProps}
        >
          {typeof content === 'string' ? <p className="m-0 leading-relaxed">{content}</p> : content}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CustomTooltip;
